import { Pipe, PipeTransform } from '@angular/core';

import { Language } from '../models/language.model';

@Pipe({
  name: 'languageName',
  standalone: true,
  pure: true
})
export class LanguageNamePipe implements PipeTransform {
  transform(languageCode: string, languages: Language[]): string {
    return languages.find((language) => language.code === languageCode)?.name;
  }
}
